import React, { Component } from 'react';
import {BeautifulCircleIcon} from './BeautifulCircleIcon';



export class CreateWidgetNameChannel extends React.Component {

    constructor(props) {
        super(props);
        console.log(this.props.data)
    }

    render() {
        return (
             
                <div className="createPage_whiteBlock">
                        <div className='whiteBlockTitle'>
                        <BeautifulCircleIcon/>
                            <div className='whiteBlockTitleSpan'>
                                Название и телеграм канал
                            </div>
                        </div>


                        <div className="whiteBlockMiddle">
                            <div className='whiteBlockTextInputBlock'>
                                <div className='whiteBlockTextInputBlock_label'>
                                    Выберите название для виджета
                                </div>
                                
                                <input onChange={e => this.props.updatePageName(e) } type='text' 
                                value={this.props.data.widget_name} />
                            {/* />*/}
                            </div>
                            <div className='whiteBlockTextInputBlock'>
                                <div className='whiteBlockTextInputBlock_label'>
                                    Введите название телеграм канала(начинается с @), для которого
                                    будет работать чат-бот
                                
                                </div>
                                <input type='text' 
                                       onChange={e => this.props.updateChannelName(e) } 
                                       value={this.props.data.channel_name}  />
                            </div>
                        </div>
                        <div className='whiteBlockButtonBlock'>
                            <a href='#' className="whiteBlockButton" onClick={this.props.goFurther}>Продолжить</a>
                        </div>
                </div>
    
            
        )
    }
}